import { Controller } from "@hotwired/stimulus"

// Stimulus controller pour un select avec recherche intégrée
export default class extends Controller {
  static targets = ["hidden", "button", "menu", "search", "options"]

  connect() {
    this.isOpen = false
    this.originalOptions = Array.from(this.optionsTarget.querySelectorAll("li"))
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.isOpen = true
    this.searchTarget.focus()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.isOpen = false
    this.searchTarget.value = ""
    this.filter()
  }

  select(event) {
    const option = event.currentTarget
    const value = option.dataset.value
    const label = option.textContent

    this.hiddenTarget.value = value
    this.buttonTarget.textContent = label
    this.close()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase()
    this.originalOptions.forEach(opt => {
      const match = opt.textContent.toLowerCase().includes(query)
      opt.style.display = match ? "" : "none"
    })
  }

  closeOnOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}